// Per-user consent API client (KVKK Aydınlatma + optional ETK opt-in).
//
// The personal counterpart to api/agreements.ts (which is the org-level signing
// flow). USE_REAL_API-gated: real mode reads pending consents off /auth/me; mock
// mode reads GET /consents/pending (MSW). The acknowledge POST is the same in
// both. Reuses AgreementsError so callers branch on the typed `code`.

import { apiUrl } from '../lib/api'
import { AgreementsError } from './agreements'
import type { PendingConsent } from '../lib/auth'

export type { PendingConsent } from '../lib/auth'

export type AcknowledgeConsentResult = {
  consent_id: string
  marketing_opt_in: boolean
}

async function toError(res: Response): Promise<AgreementsError> {
  const body = (await res.json().catch(() => null)) as {
    detail?: { code?: string; message?: string } | string
  } | null
  const env = body && typeof body.detail === 'object' ? body.detail : null
  const code = env?.code ?? 'error'
  const message =
    env?.message ?? (typeof body?.detail === 'string' ? body.detail : `HTTP ${res.status}`)
  return new AgreementsError(code, message, res.status)
}

export async function fetchPendingConsents(): Promise<PendingConsent[]> {
  const res = await fetch(apiUrl('/consents/pending'))
  if (!res.ok) throw await toError(res)
  return (await res.json()) as PendingConsent[]
}

export async function acknowledgeConsent(
  agreementId: string,
  body: { acknowledged: boolean; marketing_opt_in: boolean; accepted_locale?: string },
): Promise<AcknowledgeConsentResult> {
  const res = await fetch(apiUrl(`/consents/${agreementId}/acknowledge`), {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) throw await toError(res)
  return (await res.json()) as AcknowledgeConsentResult
}
